import React from "react";
import { motion } from "framer-motion";

const titleAnimate = {
  hidden: { y: "10vh", opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 1,
    },
  },
};

const Hero = () => {
  return (
    <div className=" bg-hero min-vh-100 overflow-hidden d-flex flex-column align-items-center justify-content-center mb-5">
      <motion.h1
        variants={titleAnimate}
        initial="hidden"
        animate="visible"
        className="display-1 logoFont text-center"
      >
        ANU1o
      </motion.h1>
      <motion.h6
        variants={titleAnimate}
        initial="hidden"
        animate="visible"
        className="text-center fw-bolder"
      >
        Portfolio of Anoof Abdul Kadar
      </motion.h6>
      <motion.div
        variants={titleAnimate}
        initial="hidden"
        animate="visible"
        className="d-flex flex-column align-items-center gap-2 p-3 bg-light border border-5 border-white opacity-75 rounded-5 shadow-sm mt-5"
      >
        <i className="fa-solid fa-helmet-safety fa-8x py-5"></i>
        <h1 className="fw-bold h1">Pardon the dust...</h1>
        <h4 className="h4">Site is undergoing some new changes.</h4>
      </motion.div>
    </div>
  );
};

export default Hero;
